import {
  React,
  Component,
  axios,
  routes,
  helpers,
  copy,
} from 'imports/CommonImports';

import 'styles/ReactTags.css';
import { WithContext as ReactTags } from 'react-tag-input';

import {
  EmailIcon,
  CopyIcon,
  DoIcon,
} from 'imports/IconsImports';

import {
  Dialog,
  RaisedButton,
  Snackbar,
  TextField,
  CircularProgress,
} from 'material-ui';

const styles = {
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly'
  },
  emailsContainer: {
    display: 'none',
    flexDirection: 'column',
    alignItems: 'center'
  },
  sendButton: {
    marginTop: '1em',
  },
  error: {
    color: '#ba0f0f',
    fontStyle: 'italic',
    fontSize: '0.8em',
  }
}

export default class PostulationShareDialog extends Component {
  constructor(props){
    super(props);
    this.state = {
      open: true,
      copyRoute: 'https://indicei3.innspiral.com/project_postulation/' + this.props.userKey,
      snackbarOpen: false,
      snackbarMessage: '',
      emails: [],
      email: '',
      emailError: false,
    };
  }

  handleConfirm = () => {
    this.props.confirm();
    // this.handleClose();
  };

  handleCancel = () => {
    this.props.cancel();
    // this.handleClose();
  };

  render() {
    return (
      <div>
        <Dialog
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleCancel}
          autoScrollBodyContent={true}
        >
          <div style={styles.buttonContainer}>
            <h3>Copiar vínculo</h3>
              <RaisedButton
                backgroundColor="#212F55"
                icon={<CopyIcon color='#FFFFFF' />}
                onClick={this.copyLink}
              />
          </div>
          <div style={styles.buttonContainer}>
            <h3>Compartir por email </h3>
            <RaisedButton
              backgroundColor="#212F55"
              icon={<EmailIcon color='#FFFFFF' />}
              onClick={this.showField}
            />
          </div>
          {this.state.sending ?
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <CircularProgress color='#9e9e9e' size={50} thickness={4} />
            </div> :
          <div id='email-field' style={styles.emailsContainer}>
            <div className='p2'> Ingresa el email de los líderes que deben agregar proyectos. Puede ser más de uno. </div>
            <ReactTags
              tags={this.state.emails}
              handleDelete={this.handleDelete}
              handleAddition={this.handleAddition}
              handleDrag={this.handleDrag}
              placeholder='Escribe los emails'/>
            <TextField
              hintText="Escribe un email y presiona 'Enter'"
              value={this.state.email}
              onChange={this.handleTags}
              onKeyPress={this.keyPressed}/>
            {this.state.emailError ? <div style={styles.error}>{this.state.emailErrorMessage}</div> : null}
            <RaisedButton
              backgroundColor='#11AB99'
              labelColor='#FFFFFF'
              label='Enviar'
              onClick={this.sendEmails}
              style={styles.sendButton}
             />
          </div>
          }
          <div style={styles.buttonContainer}>
            <h3>Agregar Directamente</h3>
            <RaisedButton
              backgroundColor='#212F55'
              icon={<DoIcon color='#FFFFFF' />}
              onClick={() => this.props.history.push('/project_postulation/' + this.props.userKey)}
            />
          </div>
          <Snackbar open={this.state.snackbarOpen} message={this.state.snackbarMessage} autoHideDuration={2000} onRequestClose={() => this.setState({snackbarOpen: false, snackbarMessage: ''})}/>
        </Dialog>
      </div>
    );
  }

  keyPressed = (event) => {

    if(event.key === 'Enter'){
      if(!helpers.validEmail(this.state.email)){
        this.setState({
          emailError: true,
          emailErrorMessage: 'El email no es válido',
        })
      }
      else{
        this.handleAddition(this.state.email);
        this.setState({
         email: '',
         emailError: false,
        });
      }
    }
  }

  handleTags = (event) => {
    this.setState({
     email: event.target.value,
    });
  }

  handleDelete = (i) => {
    let tags = this.state.emails;
    tags.splice(i, 1);
    this.setState({emails: tags});
  }

  handleAddition = (tag) => {
    let tags = this.state.emails;
    tags.push({
      id: tags.length + 1,
      text: tag
    });
    this.setState({emails: tags});
  }

  handleDrag = (tag, currPos, newPos) => {
    let tags = this.state.emails;

    // mutate array
    tags.splice(currPos, 1);
    tags.splice(newPos, 0, tag);

    // re-render
    this.setState({ emails: tags });
  }

  showField = () => {
    let field = document.getElementById('email-field');
    field.style.display = 'flex';
  }

  hideField = () => {
    let field = document.getElementById('email-field');
    field.style.display = 'none';
  }

  sendEmails = () => {
    if(this.state.emails.length > 0){
      this.setState({sending: true});
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.props.apiToken}
      });
      connection.post(routes.sendPostulationLinkEmail(this.props.company), this.state.emails.map(email=>email.text))
      .then((response) => {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: 'Los emails fueron enviados',
          sending: false,
        });
        this.hideField();
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          snackbarOpen: true,
          snackbarMessage: 'Hubo un error al enviar los emails',
          sending: false,
        });
        this.hideField();
      });
    }
    else{
      this.setState({
        emailError: true,
        emailErrorMessage: 'No has ingresado ningún email',
      });
    }
  }

  copyLink = () => {
    copy(this.state.copyRoute);
    this.setState({
      snackbarOpen: true,
      snackbarMessage: 'Link copiado al portapapeles'
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/postulation/PostulationShareDialog.js